import { ECampaignPaginationType, ECampaignStateStatus, ICampaignState } from '../models/campaigns.model';
import { Action, createReducer, on } from '@ngrx/store';
import {
  changePage,
  changePageSuccess,
  createCampaign,
  createCampaignError,
  createCampaignSuccess,
  deleteCampaign,
  deleteCampaignError,
  deleteCampaignSuccess,
  getCampaignInfo,
  getCampaignInfoError,
  getCampaignInfoSuccess,
  loadCampaigns,
  loadCampaignsError,
  loadCampaignsSuccess,
  restoreCampaign,
  restoreCampaignError,
  restoreCampaignSuccess,
  updateCampaign,
  updateCampaignError,
  updateCampaignSuccess,
} from '../actions/campaigns.action';

const initialState: ICampaignState = {
  active_campaigns: [],
  deleted_campaigns: [],
  pending_campaigns: [],
  status: ECampaignStateStatus.INITIALIZING,
  error: null,
  pagination: {
    active_campaigns: {
      type: ECampaignPaginationType.ACTIVE,
      current_page: 0,
      has_more_data: false,
      has_previous: false,
      page_size: 15,
      total_pages_count: 0,
      count: 0,
    },
    deleted_campaigns: {
      type: ECampaignPaginationType.DELETED,
      current_page: 0,
      has_more_data: false,
      has_previous: false,
      page_size: 15,
      total_pages_count: 0,
      count: 0,
    },
    pending_campaigns: {
      type: ECampaignPaginationType.PENDING,
      current_page: 0,
      has_more_data: false,
      has_previous: false,
      page_size: 15,
      total_pages_count: 0,
      count: 0,
    },
  },
};

const campaignsReducer = createReducer(
  initialState,
  on(loadCampaigns, (state, { pagination }) => {
    return {
      ...state,
      status: ECampaignStateStatus.LOADING,
      active_campaigns: [],
      pending_campaigns: [],
      deleted_campaigns: [],
      pagination: {
        ...state.pagination,
        pagination,
      },
    };
  }),
  on(
    loadCampaignsSuccess,
    (
      state,
      { active_campaigns, pending_campaigns, deleted_campaigns, pagination },
    ) => {
      return {
        ...state,
        status: ECampaignStateStatus.READY,
        active_campaigns,
        pending_campaigns,
        deleted_campaigns,
        pagination,
      };
    },
  ),
  on(loadCampaignsError, (state, { error }) => {
    return {
      ...state,
      state: ECampaignStateStatus.ERROR,
      error,
    };
  }),
  on(changePage, (state, { page, campaign_type }) => {
    return {
      ...state,
      status: ECampaignStateStatus.READY,
      pagination: {
        ...state.pagination,
        [campaign_type]: {
          ...state.pagination[campaign_type],
          current_page: page,
        },
      },
    };
  }),
  on(changePageSuccess, (state, { campaign_type, items, pagination }) => {
    return {
      ...state,
      status: ECampaignStateStatus.READY,
      [campaign_type]: items,
      pagination: {
        ...state.pagination,
        ...pagination,
      },
    };
  }),
  on(updateCampaign, state => {
    return {
      ...state,
      status: ECampaignStateStatus.LOADING,
    };
  }),
  on(updateCampaignSuccess, (state, { response }) => {
    return {
      ...state,
      status: ECampaignStateStatus.UPDATED,
      update_response: response,
    };
  }),
  on(updateCampaignError, (state, { error }) => {
    return {
      ...state,
      status: ECampaignStateStatus.ERROR,
      error,
    };
  }),
  on(getCampaignInfo, state => {
    return {
      ...state,
      status: ECampaignStateStatus.LOADING,
    };
  }),
  on(getCampaignInfoSuccess, (state, { campaign }) => {
    return {
      ...state,
      currentCampaign: campaign,
      status: ECampaignStateStatus.READY,
    };
  }),
  on(getCampaignInfoError, (state, { error }) => {
    return {
      ...state,
      error,
      status: ECampaignStateStatus.ERROR,
    };
  }),
  on(createCampaign, state => {
    return {
      ...state,
      status: ECampaignStateStatus.LOADING,
    };
  }),
  on(createCampaignSuccess, (state, { campaign_id }) => {
    return {
      ...state,
      status: ECampaignStateStatus.CRATED,
      new_campaign_id: campaign_id,
    };
  }),
  on(createCampaignError, (state, { error }) => {
    return {
      ...state,
      status: ECampaignStateStatus.ERROR,
      error,
    };
  }),
  on(deleteCampaign, (state, { campaign }) => {
    return {
      ...state,
      currentCampaign: campaign,
      status: ECampaignStateStatus.LOADING,
    };
  }),
  on(deleteCampaignSuccess, (state, { response }) => {
    return {
      ...state,
      status: ECampaignStateStatus.UPDATED,
      update_response: response,
    };
  }),
  on(deleteCampaignError, (state, { error }) => {
    return {
      ...state,
      status: ECampaignStateStatus.ERROR,
      error,
    };
  }),
  on(restoreCampaign, (state, { campaign }) => {
    return {
      ...state,
      currentCampaign: campaign,
      status: ECampaignStateStatus.LOADING,
    };
  }),
  on(restoreCampaignSuccess, (state, { response }) => {
    return {
      ...state,
      status: ECampaignStateStatus.UPDATED,
      update_response: response,
    };
  }),
  on(restoreCampaignError, (state, { error }) => {
    return {
      ...state,
      status: ECampaignStateStatus.ERROR,
      error,
    };
  }),
);

export function reducer(state: ICampaignState, action: Action) {
  return campaignsReducer(state, action);
}
